import {
  logoOverlayRightDark,
  logoOverlayRightLight,
} from "@/assets/overlays/logoOverlay.js";
import { textbox, lowerThird } from "@/assets/overlays/textbox.js";
import Vuetify from "@/plugins/vuetify";

export const layerItems = [
  {
    id: "logo-000001",
    htmlTemplate: logoOverlayRightLight,
    params: [
      {
        key: "LOGOTYPE",
        type: "select",
        options: ["LIGHT", "DARK"],
        overwriteTemplate: true,
        defaultValue: "LIGHT",
        templates: {
          LIGHT: logoOverlayRightLight,
          DARK: logoOverlayRightDark,
        },
      },
    ],
    title: { de: "Logo Einblendung", en: "Logo overlay" },
    description: {
      de: "Blende dein Logo ein",
      en: "Overlay your logo",
    },
  },
  {
    id: "lower-third-000001",
    htmlTemplate: lowerThird,
    params: [
      {
        key: "TITLE",
        type: "textfield",
        required: true,
        translation: {
          en: "Title (e.g. Name)",
          de: "Titel (z.B. Name der Person)",
        },
      },
      {
        key: "DESCRIPTION",
        type: "textfield",
        translation: {
          en: "Description (e.g. current position)",
          de: "Untertitel (z.B. Position der Person)",
        },
      },
      {
        key: "BRANDING_PRIMARY_COLOR",
        type: undefined,
        defaultValue: Vuetify.framework.theme.themes.light.primary,
      },
      {
        key: "BRANDING_ACCENT_COLOR",
        type: undefined,
        defaultValue: Vuetify.framework.theme.themes.light.accent,
      },
      {
        key: "START_AT",
        type: undefined,
        defaultValue: 2,
        translation: {
          en: "Fade in at second (default: 2s)",
          de: "Bauchbinde einblenden bei Sekunde (Standard: 2s)",
        },
      },
      {
        key: "END_AT",
        type: undefined,
        defaultValue: 6,
        translation: {
          en: "Fade out at second (default: 6s)",
          de: "Bauchbinde ausblenden bei Sekunde (Standard: 6s)",
        },
      },
      {
        key: "FADE_DURATION",
        type: undefined,
        defaultValue: 1,
      },
    ],
    title: { de: "Bauchbinde", en: "Lower Third" },
    description: {
      de: "Texteinblendung unten links",
      en: "Add information to this clip",
    },
  },
  {
    id: "textbox-000001",
    htmlTemplate: textbox,
    params: [
      {
        key: "TITLE",
        type: "textfield",
        required: true,
        translation: {
          en: "Title",
          de: "Titel",
        },
      },
      {
        key: "DESCRIPTION",
        type: "textarea",
        maxLength: 200,

        translation: {
          en: "Description",
          de: "Text",
        },
      },
      {
        key: "BRANDING_PRIMARY_COLOR",
        type: undefined,
        defaultValue: Vuetify.framework.theme.themes.light.primary,
      },
      {
        key: "BRANDING_ACCENT_COLOR",
        type: undefined,
        defaultValue: Vuetify.framework.theme.themes.light.accent,
      },
      {
        key: "START_AT",
        type: undefined,
        defaultValue: 2,
        translation: {
          en: "Fade in at second (default: 2s)",
          de: "Texteinblendung einblenden bei Sekunde (Standard: 2s)",
        },
      },
      {
        key: "END_AT",
        type: undefined,
        defaultValue: 12,
        translation: {
          en: "Fade out at second (default: 6s)",
          de: "Texteinblendung ausblenden bei Sekunde (Standard: 6s)",
        },
      },
      {
        key: "FADE_DURATION",
        type: undefined,
        defaultValue: 1,
      },
    ],
    title: { de: "Texteinblendung", en: "Textbox" },
    description: {
      de: "Texteinblendung unten links",
      en: "Add information to this clip",
    },
  },
];
